/**
 * @deprecated Use @faire/web--source/common/delay instead
 */ export var theFuture = function() {
    var millisecondsInTheFuture = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new Promise(function(resolve) {
        return setTimeout(resolve, millisecondsInTheFuture);
    });
};
